import { render, staticRenderFns } from "./DeviceMinimalItem.vue?vue&type=template&id=fb49fc50"
import script from "./DeviceMinimalItem.vue?vue&type=script&lang=ts"
export * from "./DeviceMinimalItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports